// Angular
import { Component,Input } from '@angular/core';

@Component({
	selector: 'cv-public-record-item',
	templateUrl: './public-record-item.component.html'
})
export class PublicRecordItemComponent {
	@Input() publicRecord: any;
	@Input() selected: boolean;

	get address(): string {
		let txt = `${this.publicRecord.propertyRecord.streetName} #${this.publicRecord.propertyRecord.streetNumber}`;

		if (this.publicRecord.propertyRecord.streetName === '' || this.publicRecord.propertyRecord.streetName === null) {
			txt = this.publicRecord.propertyRecord.unparsedAddress;
		}

		return txt;
	}
}
